export const moveUploadModalContentHeight = '400px';
export const moveUploadModalContentWidth = '432px';
